<div
  [class]="containerClasses"
  [class.hidden]="hidden"
  (click)="onClick()"
  (keydown)="onKeyDown($event)"
  tabindex="0"
>
  <span [class]="textClasses" #text>
    <ng-content></ng-content>
  </span>
</div>
